import { createSelector } from 'reselect'

export const selectClientTeamMemberships = state => state.clientTeamMemberships

export const selectUnverifiedMembership = createSelector(
  selectClientTeamMemberships,
  memberships => memberships?.data?.find(membership => !membership.isVerified) || null
)

export const selectVerifiedClientTeamMemberships = createSelector(
  selectClientTeamMemberships,
  memberships => memberships?.data?.filter(membership => membership.isVerified) || []
)

export const selectClientHasUnverifiedAgent = createSelector(selectUnverifiedMembership, unverifiedMembership => {
  console.log(unverifiedMembership)
  return unverifiedMembership !== null
})

export const selectPreferredLoanOfficerMembership = createSelector(
  selectClientTeamMemberships,
  memberships => memberships?.data?.find(membership => membership.customerProfile.type === 'LoanOfficer') || null
)

export const selectPreferredRealEstateAgentMembership = createSelector(
  selectClientTeamMemberships,
  memberships => memberships?.data?.find(membership => membership.customerProfile.type === 'RealEstateAgent') || null
)
